import { IconAndText } from '@blueprint/ui';
import { Feature, Maybe } from '../graphql.generated';
import getListingFeatures from './getListingFeatures';
import { FeatureList, FeatureListItem } from './ListingFeatureList.styles';

type ListingFeaturesProps = {
    features?: Maybe<Array<Maybe<Feature>>>;
};

const ListingFeatureList = ({ features }: ListingFeaturesProps) => {
    if (!features?.length) {
        return null;
    }

    const listingFeatures = getListingFeatures(features);

    return (
        <FeatureList>
            {listingFeatures?.map((item, idx) => (
                <FeatureListItem
                    key={`${item.iconId}-${idx}`}
                    data-testid={`${item.iconId}-feature`}
                >
                    <IconAndText
                        isInline
                        iconId={item.iconId}
                        content={item.content}
                        iconColor="text-body"
                        contentColor="text-title"
                        size="medium"
                    />
                </FeatureListItem>
            ))}
        </FeatureList>
    );
};

export default ListingFeatureList;
